import { render, staticRenderFns } from "./MyCompanyHome.vue?vue&type=template&id=7a059f36&"
import script from "./MyCompanyHome.vue?vue&type=script&lang=js&"
export * from "./MyCompanyHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports